import type { ReactNode } from 'react';

import { Box, type BoxProps } from '@chakra-ui/react';

export type PageContentRootProps = BoxProps & {
  children?: ReactNode;
};

/**
 * Root wrapper for scrollable page body inside the app layout `Container`
 * (below the sticky header). Distinct from `PageHeaderPortal`, which portals
 * into the shell header.
 */
export function PageContentRoot({
  children,
  p = 4,
  width = '100%',
  ...rest
}: PageContentRootProps) {
  return (
    <Box p={p} width={width} {...rest}>
      {children}
    </Box>
  );
}
